import { type TableSelectedCell, useTableRows } from '@/components/custom/erp';
import { isValidUUID } from '@/lib/uuid-validator';

export type SelectedDetailCellInfo = TableSelectedCell;

export interface DetailRow {
  uuid: string;
  line?: number;
  [key: string]: any;
}

const createFieldUpdates = (row: DetailRow, field: string, value: any): Partial<DetailRow> => {
  const updatedRow: DetailRow = { ...row, [field]: value };
  const updates: Partial<DetailRow> = { [field]: value };

  if (field === 'ma_kh_data') {
    updates.id_tt = 0;
    updates.id_tt_data = null;
  } else if (field === 'id_tt_data') {
    updates.id_tt = isValidUUID(value?.document_uuid) || 0;
  }

  // Calculate tien_nt0 when gia_nt0 or so_luong changes
  if (field === 'gia_nt0') {
    const so_luong = Number(updatedRow.so_luong) || 1;
    const gia_nt0 = Number(value) || 0;
    const tien_nt0 = gia_nt0 * so_luong;
    updates.tien_nt0 = tien_nt0;
  } else if (field === 'so_luong') {
    const gia_nt0 = Number(updatedRow.gia_nt0) || 0;
    const so_luong = Number(value) || 1;
    const tien_nt0 = gia_nt0 * so_luong;
    updates.tien_nt0 = tien_nt0;
  }

  // Calculate tax (thue_nt) when relevant fields change
  const shouldCalculateTax = ['tien_nt0', 'gia_nt0', 'ma_thue_data'].includes(field);
  if (shouldCalculateTax) {
    const finalRow = { ...updatedRow, ...updates };
    const baseAmount = finalRow.tien_nt0 || (finalRow.gia_nt0 || 0) * (finalRow.so_luong || 0) || 0;
    const taxRate = finalRow.ma_thue_data?.thue_suat || 0;
    const calculatedTax = (baseAmount * taxRate) / 100;
    updates.thue_nt = calculatedTax;
  }

  return updates;
};

export function useDetailRows(initialRows: DetailRow[] = [], onChange?: (rows: DetailRow[]) => void) {
  const {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange: baseHandleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs
  } = useTableRows<DetailRow>({
    initialRows,
    defaultRows: 1,
    onChange,
    onFieldValueChange: createFieldUpdates,
    defaultField: 'tk'
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange: baseHandleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setSelectedRowUuid,
    setSelectedRow,
    setSelectedCell,
    setNonWritableFields,
    setPasteConfigs
  };
}
